import { useEffect } from 'react'

export const ORDER_SHIPPING_EXCEL_UPLOAD_LEAVE_MESSAGE = '송장 엑셀 업로드는 완료 전에 이동하면 취소될 수 있습니다. 이동하시겠습니까?'

export const hasPendingOrderShippingExcelUpload = (excelActionLoading) => {
    return excelActionLoading === 'upload-epost' || excelActionLoading === 'upload-lotte'
}

// 엑셀 업로드 요청이 진행 중일 때만 화면 이탈 경고를 띄운다.
export const usePendingOrderShippingExcelUploadUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
